// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/shield-check.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/shield-check'

import { Icon, type IconComponentProps } from '../icon'

export const ShieldCheckIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
